import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const PlusIcon = ({
  width = 24,
  height = 24,
  stroke = '#A0A4A8',
  strokeWidth = 2,
  margin,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    style={{ margin }}
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M12 5v14M5 12h14"
    />
  </svg>
);
